define('views/signup/Podio.Views.SignupForm',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','lib/Podio.Routes'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioViewBase = require('lib/backbone/Backbone.PodioView');
  var podioRoutes = require('lib/Podio.Routes');

  return PodioViewBase.extend({
    initialize: function() {
      _.bindAll(this, 'onRemoteEmailValidation', 'onRemoteEmailValidationStart');
      this._super();
      this.emailElm = this.elm.find('input#user_mail');
      this.emailElm.bind('validation:email:start', this.onRemoteEmailValidationStart);
      this.emailElm.bind('validation:email:result', this.onRemoteEmailValidation);
    },

    onRemoteEmailValidationStart: function() {
      this.feedbackElm().empty();
    },

    onRemoteEmailValidation: function(event, data) {
      if (!data.valid) {
        this.showEmailError(data.error_id, data.error);
      }

      this.showEmailSuggestions(data.suggestions);
    },

    emailContainer: function() {
      return this.emailElm.closest(this.options.emailContainerSelector);
    },

    feedbackElm: function() {
      var feedback = this.emailContainer().find('.feedback');

      if (!feedback.length) {
        feedback = $('<div/>', { 'class': 'feedback' });
        this.emailContainer().append(feedback);
      }

      return feedback;
    },

    feedback: function(html) {
      this.feedbackElm().html(html);
    },

    suggestionWithYesHandler: function(questionText, yesHandler) {
      var self = this;
      var content = $('<div/>', { 'class': 'suggestion', text: questionText });
      var yesLink = $('<a/>', { text: t('yes #signup'), href: '#' });
      var noLink = $('<a/>', { text: t('no #signup'), href: '#' });
      var noHandler = function(event) {
        event.preventDefault();
        self.feedbackElm().empty();
      };

      content.append(yesLink);
      content.append(noLink);
      yesLink.bind('click', yesHandler);
      noLink.bind('click', noHandler);
      return content;
    },

    showEmailSuggestions: function(suggestions) {
      var existingInactiveUser = _.findWhere(suggestions, { code: 'existing_inactive' });
      var didYouMean = _.findWhere(suggestions, { code: 'did_you_mean' });
      var googleSSO = _.findWhere(suggestions, { code: 'google_sso' });

      if (existingInactiveUser) {
        this._hideUsernameAndPasswordFields();
        var link = $('<a/>', {
          href: podioRoutes.signup_resend_confirm_email_path({ format: 'html', email: this.emailElm.val()}),
          text: t('Resend verification mail? #signup')
        });
        var text = t('This user already exists, but has not been verified yet. #signup');
        this.feedback($('<div/>', { 'class': 'suggestion', text: text }).append(link));
        this._setSubmitButtonDisabled(true);
      } else {
        this._showUsernameAndPasswordFields();
        this._setSubmitButtonDisabled(false);

        if (didYouMean) {
          this._showDidYouMeanSuggestion(didYouMean.mail);
        } else if (googleSSO) {
          this._showGoogleSSOSuggestion();
        }
      }
    },

    showEmailError: function(error_id, description) {
      var text, link;

      if (error_id === 'common.mail.invalid') {
        text = t('Please have a look, this email address is invalid. #signup');
        this.feedback($('<div/>', { 'class': 'error', text: text }));
      } else if (error_id === 'user.existing') {
        link = $('<a/>', {
          href: podioRoutes.recover_password_path({ format: 'html' }),
          text: t('Reset password? #signup')
        });
        text = t('This user already exists. #signup');
        this.feedback($('<div/>', { 'class': 'error', text: text }).append(link));
      }
    },

    _showDidYouMeanSuggestion: function(mail) {
      var self = this;

      var question = t('Did you mean {0}? #signup').format(mail);
      var content = this.suggestionWithYesHandler(question, function(event) {
        event.preventDefault();
        self.emailElm.focus().val(mail).blur();
      });

      this.feedback(content);
    },

    _showGoogleSSOSuggestion: function() {
      var self = this;
      var content = this.suggestionWithYesHandler(t('Would you like to sign in with Google? #signup'), function(event) {
        event.preventDefault();
        self._loginWithGoogle();
      });
      this.feedback(content);
    },

    _loginWithGoogle: function() {
      $("form[data-provider='google']").submit();
    },

    _hideUsernameAndPasswordFields: function() {
      $('#user_name, #user_password').closest('dd').slideUp().prev('dt').slideUp();
    },

    _showUsernameAndPasswordFields: function() {
      $('#user_name, #user_password').closest('dd').slideDown().prev('dt').slideDown();
    },

    _setSubmitButtonDisabled: function(disable) {
      $('button.setupbutton')
        .toggleClass('disabled', disable)
        .prop('disabled', disable);
    }
  });
});

